import { STORE_RANKING_FILTER, TASK_SORTING } from './enums'
import { IMenuItem } from './interfaces'
import keys from './keys'

export const defaultTaskStatuses = {
  [keys.TASK_STATUSES.TODO.value]: 0,
  [keys.TASK_STATUSES.INPROGRESS.value]: 0,
  [keys.TASK_STATUSES.DONE.value]: 0,
  [keys.TASK_STATUSES.DISAPPROVED.value]: 0,
  [keys.TASK_STATUSES.APPROVED.value]: 0,
}

export const TASK_SORTING_VARIANTS: IMenuItem[] = [
  { id: 0, literal: 'task_start_date', value: TASK_SORTING.STARTING_DATE.toString() },
  { id: 1, literal: 'priority', value: TASK_SORTING.PRIORITY.toString() },
]
// eslint-disable-next-line
export const regExLinkRecognizer =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/

// count of tasks which will be rendered on notification page
export const TASKS_NOTIFICATION_COUNT = 7
export const OTHER_TASK_VIEW_ID = 'other'

export const OTHER_TASK_VIEW = {
  task_view_id: 'other',
  task_view_name: 'task_type_others',
  icon: 'https://sales-media.apps-checkout.com/default/icons/others.svg',
  order: 1000,
  color: '#ccc',
  literal: 'task_type_others',
}

export const defaultStoreFilter = {
  id: STORE_RANKING_FILTER.ALL_CHAIN,
  name: 'ranking_filter_all_chain',
  value: STORE_RANKING_FILTER.ALL_CHAIN,
}

export const contactUsOnWhatsApp = 'https://api.whatsapp.com/send/?phone='

export const dateOptionsDefault = [
  { id: '0', name: 'search_feed_date_filter_today', isSelected: false },
  { id: '1', name: 'search_feed_date_filter_yesterday', isSelected: false },
  { id: '2', name: 'search_feed_date_filter_seven_days', isSelected: false },
  { id: '3', name: 'search_feed_date_filter_thirty_days', isSelected: false },
  { id: '4', name: 'search_feed_date_filter_range', isSelected: false },
]

export const mediaOptionsDefault = [
  {
    id: '1',
    name: 'search_feed_filter_with_audio',
    isSelected: false,
  },
]

/**
 * Retailer IDs that show the FlowSelectDrawer (list view vs category view)
 * when creating or editing VM tasks.
 * Add new retailer IDs here to enable the feature for them.
 */
export const VM_TASK_FLOW_SELECT_RIDS: string[] = ['live', 'stimatzky']

/**
 * Retailer IDs that have a preset list of default task categories
 * shown in CategorySelector and CategoryModal.
 * Add new retailer IDs here to enable default categories for them.
 */
export const VM_TASK_DEFAULT_CATEGORIES_RIDS: string[] = ['live']
export const STOREE_AI_UID = 'sto-ai'
